import type { Configuration, IRequest } from '../..';
import HttpMethod from '../../request/HttpMethod';
import HttpStatusCode from '../../request/HttpStatusCode';
import Requester from '../../request/Requester';

export class FleetRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public uploadLogo = (blob: Blob): Promise<string> => {
    const requestData: IRequest = {
      endpoint: 'dash/fleet/logo',
      method: HttpMethod.POST,
      body: blob,
      headers: {
        'Content-type': 'application/octet-stream',
      },
    };
    return this.requester.request(requestData).then((response) => response.data.logo_url);
  };

  public getLogoUrl = (fleetId: string): Promise<string> => {
    const requestData: IRequest = {
      endpoint: `dash/fleet/logo?fleet_id=${fleetId}`,
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData, [HttpStatusCode.NOT_FOUND]).then((response) => response.data.logo_url);
  };

  public deleteLogo = (): Promise<null> => {
    const requestData: IRequest = {
      endpoint: 'dash/fleet/logo',
      method: HttpMethod.DELETE,
    };
    return this.requester.request(requestData).then(() => null);
  };
}

export default FleetRequester;
